import React, {
  // useCallback,
  useEffect,
  // useMemo,
  useRef,
  useState,
} from "react";
import { useFeatureFlag } from "contexts/FeatureFlagContext";
import { useFindingDetails } from "./FindingDetailsProvider";
import FindingHistoryV2, { getToolCommentsTabDisplayName, shouldRenderToolsComments } from "../FindingHistoryV2";
import FindingAPI from "restAPI/FindingAPI";
import { getCommentChangeAPIFunction } from "components/CommentComponent";
// import { getErrorMessage } from "utils/errorUtil";
import { isEmpty } from "lodash";
// import axios from "axios";
// import message from "components/CustomMessage";
// import AppLoader from "components/AppLoader";
// import { AttachmentsListing } from "../Attachments";
// import { attachmentTools } from "../utils";
// import { removeNonPrintableUnicodeCharacters } from "utils/fileUtils";
import ACTabs from "ac-components/ac-tabs/ACTabs";
import ACSettingSectionTitle from "ac-components/ac-setting-section-title/ACSettingSectionTitle";
import ACSettingSectionCard from "ac-components/ac-setting-section-card/ACSettingSectionCard";
import ACTabContent from "ac-components/ac-tab-content/ACTabContent";
import ComingSoonTooltip from "components/ComingSoonTooltip";
import { getEmptyCancellableRequest } from "restAPI";
import { TicketsTabTitle } from "./FindingDetailsTickets";
import FindingDetailsTicket from "./FindingDetailsTicket";
import FindingExceptionDetails from "./FindingExceptionDetails";
import Vocabulary from "components/Vocabulary";
import { hasPermission } from "utils/authService";
import { PermissionSetMap } from "constants/RBACConstants";
import FindingComment from "./FindingComment";
import SimilarVersionFindingsTable from "./SimilarVersionFindingsTable";

export function FindingDetailsComments({ designV3 = true }) {
  const { finding, loading } = useFindingDetails();
  const featureFlags = useFeatureFlag();
  const commentRef = useRef();
  const mountRef = useRef(false);

  useEffect(() => {
    if (mountRef.current === false) {
      if (!loading) {
        mountRef.current = true;
      }
      return;
    }
    
    if (commentRef.current) {
      commentRef.current.fetchEvents();
    }
  }, [finding, loading]);

  const [activeTab, setActiveTab] = useState("comments");

  return (
    <>
      <ACSettingSectionTitle
        title="Activity"
        description="What’s going on with this finding?"
      />
      <ACSettingSectionCard
        title={
          <ACTabs
            responsive
            value={activeTab}
            onChange={setActiveTab}
            size="sm"
            items={[
              {
                label: "Comments",
                value: "comments",
              },
              {
                label: "History",
                value: "history",
              },
              // {
              //   label: "Attachments",
              //   value: "attachments",
              // },
              {
                label: <TicketsTabTitle />,
                value: "tickets",
              },
              shouldRenderToolsComments(finding, featureFlags)
                ? {
                    label: getToolCommentsTabDisplayName(finding),
                    value: "toolComments",
                  }
                : undefined,
              {
                label: featureFlags.VERSIONS ? (
                  "Versioned Findings"
                ) : (
                  <ComingSoonTooltip>Versioned Findings</ComingSoonTooltip>
                ),
                value: "versionedFindings",
                disabled: !(
                  featureFlags.VERSIONS &&
                  (finding?.productVersion || finding?.subProductVersion)
                ),
              },
              ...(featureFlags.EXCEPTION_MODULE && hasPermission(PermissionSetMap.READ_RISK_REGISTER) ? [{
                value: "exceptions",
                label: <Vocabulary name="exception"/>
              }] : [])
            ].filter((f) => !isEmpty(f))}
          />
        }
      >
        <ACTabContent
          value={activeTab}
          items={[
            {
              content: (
                <FindingComment
                  finding={finding}
                />
              ),
              value: "comments",
            },
            {
              content: (
                <FindingHistoryV2
                  ref={commentRef}
                  finding={finding}
                  featureFlags={featureFlags}
                  getHistory={FindingAPI.getEvents}
                  getComment={() => getEmptyCancellableRequest({content: []})}
                  postComment={getCommentChangeAPIFunction}
                  fixedContent="history"
                />
              ),
              value: "history",
            },
            {
              content: <FindingDetailsTicket />,
              value: "tickets",
            },
            // {
            //   content: <FindingAttachmentSection />,
            //   value: "attachments",
            // },
            {
              content: (
                <FindingHistoryV2
                  ref={commentRef}
                  finding={finding}
                  featureFlags={featureFlags}
                  getHistory={() => getEmptyCancellableRequest({content: []})}
                  getComment={() => getEmptyCancellableRequest({content: []})}
                  postComment={getCommentChangeAPIFunction}
                  fixedContent="toolComments"
                />
              ),
              value: "toolComments",
            },
            {
              content: <SimilarVersionFindingsTable />,
              value: "versionedFindings",
            },
            {
              content: <FindingExceptionDetails finding={finding}/>,
              value: "exceptions"
            }
          ]}
        />
      </ACSettingSectionCard>
    </>
  );
}

// function FindingAttachmentSection() {
//   const { finding, loading, onUpdate, id } = useFindingDetails();
//   const [attachments, setAttachments] = useState();
//   const [attachmentErr, setAttachmentErr] = useState([]);
//   const [fileList, setFileList] = useState([]);
//   const [attachmentUploading, setAttachmentUploading] = useState(false);

//   const fetchAttachments = useCallback(async () => {
//     const params = {
//       id: finding.toolId,
//       productId: finding.product?.id,
//       subProductId: finding.appId,
//       environment: finding.envName,
//     };
//     try {
//       const res = await FindingAPI.getAttachments(finding.toolName, params)
//         .promise;
//       setAttachments(res);
//     } catch (e) {
//       const errMsg = getErrorMessage(e);
//       setAttachmentErr(errMsg);
//       setAttachments([]);
//     }
//   }, [finding]);

//   useEffect(() => {
//     if (!loading) {
//       if (attachmentTools.includes(finding.toolName)) {
//         fetchAttachments();
//       }
//     }
//   }, [fetchAttachments, loading, finding]);

//   const attachmentData = useMemo(() => {
//     const customAttachments = _.map(finding?.attachments || [], (item) => ({
//       ...item,
//       isCustomAttachment: true,
//     }));
//     return [
//       ...(attachments instanceof Array ? attachments : []),
//       ...customAttachments,
//     ];
//   }, [attachments, finding]);

//   const onAttachmentDelete = useCallback(
//     async (_, item) => {
//       await FindingAPI.deleteAttachment(finding.id, item.id).promise;
//       message.success("Successfully deleted attachment");
//       onUpdate(true);
//     },
//     [finding, onUpdate]
//   );

//   const onFileChange = useCallback(
//     async (e) => {
//       const file = e.file;
//       setFileList(e.fileList);
//       if (file) {
//         const { id: attachmentId, signedUrl } = await FindingAPI.uploadFindingAttachment(id, {
//           fileName: removeNonPrintableUnicodeCharacters(file.name),
//         }).promise;
//         try {
//           setAttachmentUploading(true);
//           await axios({ method: "put", url: signedUrl, data: file });
//           message.success("Successfully uploaded attachment");
//           FindingAPI.uploadFindingAttachmentToTicket(id, {
//             attachmentId,
//             signedUrl
//           });
//           setAttachmentUploading(false);
//           setFileList([]);
//           onUpdate(true);
//         } catch (e) {
//           console.log("upload fidning attachment err", e);
//         }
//       }
//     },
//     [id, onUpdate]
//   );

//   if (loading) {
//     return <AppLoader />;
//   }
//   return (
//     <AttachmentsListing
//       toolName={finding.toolName}
//       dataSource={attachmentData}
//       attachmentErr={attachmentErr}
//       onDeleteAttachment={onAttachmentDelete}
//       onFileChange={onFileChange}
//       uploading={attachmentUploading}
//       fileList={fileList}
//     />
//   );
// }
